import React from 'react';
import {
  SectionCategory,
  SECTION_CATEGORY_LABELS,
} from './types';
import { PRIMARY, BORDER_LIGHT, TEXT_DARK } from '../../../components/legacy-ball/table-management/designTokens';

interface FilterBarProps {
  activeCategory: SectionCategory | null;
  onCategoryChange: (category: SectionCategory | null) => void;
}

// Only show these categories in the filter bar
const VISIBLE_CATEGORIES: SectionCategory[] = [
  'GeneralArticles',
  'TileSpacePurchasers',
  'Advertisers',
  'MemorialTributes',
];

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    padding: '12px 0',
    borderBottom: `1px solid ${BORDER_LIGHT}`,
    marginBottom: '16px',
    alignItems: 'center',
  },
  button: {
    padding: '6px 14px',
    fontSize: '0.85rem',
    borderRadius: '6px',
    border: `1px solid ${BORDER_LIGHT}`,
    backgroundColor: '#f3f4f6',
    color: TEXT_DARK,
    cursor: 'pointer',
    transition: 'background-color 0.15s, color 0.15s',
    fontWeight: 500,
    lineHeight: 1.4,
  },
  buttonActive: {
    padding: '6px 14px',
    fontSize: '0.85rem',
    borderRadius: '6px',
    border: `1px solid ${PRIMARY}`,
    backgroundColor: PRIMARY,
    color: '#ffffff',
    cursor: 'pointer',
    transition: 'background-color 0.15s, color 0.15s',
    fontWeight: 500,
    lineHeight: 1.4,
  },
};

export function FilterBar({ activeCategory, onCategoryChange }: FilterBarProps) {
  const handleClick = (category: SectionCategory | null) => {
    if (category === null) {
      onCategoryChange(null);
    } else if (activeCategory === category) {
      onCategoryChange(null);
    } else {
      onCategoryChange(category);
    }
  };

  return (
    <div style={styles.container} role="toolbar" aria-label="Filter by document type">
      <button
        style={activeCategory === null ? styles.buttonActive : styles.button}
        onClick={() => handleClick(null)}
        aria-pressed={activeCategory === null}
      >
        All
      </button>
      {VISIBLE_CATEGORIES.map((category) => {
        const isActive = activeCategory === category;
        return (
          <button
            key={category}
            style={isActive ? styles.buttonActive : styles.button}
            onClick={() => handleClick(category)}
            aria-pressed={isActive}
          >
            {SECTION_CATEGORY_LABELS[category]}
          </button>
        );
      })}
    </div>
  );
}
